<script setup lang="ts">
// PROPS
const { reverse } = defineProps({
    title: { type: String, default: '' },
    description: { type: String, default: '' },
    image: { type: String, required: true },
    reverse: { type: Boolean, default: false },
});

// DATA
const orderClass = computed(() => (reverse ? 'lg:order-last' : 'lg:order-first'));
</script>

<template>
    <BaseWidthContainer>
        <div class="mx-auto flex flex-col items-center gap-y-8 lg:grid lg:grid-cols-3 lg:gap-x-8">
            <img :src="image" alt="" role="presentation" class="w-full max-w-[367px]" :class="orderClass" />
            <div class="flex flex-col gap-y-8 lg:col-span-2">
                <h3 v-if="$slots.title || !!title" class="text-primary-800 text-3xl font-semibold">
                    <slot name="title">{{ title }}</slot>
                </h3>
                <div v-if="$slots.description || !!description" class="text-base">
                    <slot name="description">{{ description }}</slot>
                </div>
            </div>
        </div>
    </BaseWidthContainer>
</template>
